import { PlanoEnum } from "app/shared/components/enums/plano.enum";

export class ImobiliariaResponse {
  id: number;
  nome: string;
  cpfCnpj: string;
  telefone: string;
  planoId: PlanoEnum;
  tagImobiliaria: string;
  ativoFlag: boolean;

  constructor(p: any) {
    this.id = p.id !== undefined ? p.id : null;
    this.nome = p.nome !== undefined ? p.nome : null;
    this.cpfCnpj = p.cpfCnpj !== undefined ? p.cpfCnpj : null;
    this.telefone = p.telefone !== undefined ? p.telefone : null;
    this.planoId = p.planoId !== undefined ? p.planoId : null;
    this.tagImobiliaria = p.tagImobiliaria !== undefined ? p.tagImobiliaria : null;
    this.ativoFlag = p.ativoFlag !== undefined ? p.ativoFlag : null;
  }

  get planoFmt(): string {
    return PlanoEnum[this.planoId];
  }

  get ativo(): string {
    return this.ativoFlag ? 'Sim' : 'Não';
  }
}